import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import { reduxForm, Field } from "redux-form";
import { SimpleField} from "../../common/Inputs";
import * as fetchingState from '../../../constants/fetchingState';
import { connect } from "react-redux";
import { documents } from '../../../constants/settingTypes';
const validate = (values, props) => {
    const errors = {};
    const required = type => {
        if (!values[type] || values[type].length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
    }

    required('Name');
    required('Link');    


    return errors;
}

let EditModal = class extends React.Component {
    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
    }

    _onSubmit(values) {      
        this.props.onSubmit(values);
    }

    render() {
        const {
            fetching,
            onClose,
            handleSubmit,
            anyTouched,
            error,
            isNew,
            pristine,
            crudError } = this.props;

        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{isNew ? 'Новый Документ' : 'Редактирование Документа'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && <form className='form-horizontal'>    
                        <Field name='Name' component={SimpleField} label='Название ссылки' />
                        <Field name='Link' component={SimpleField} label='Ссылка на файл' />
                        
                        {anyTouched && error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}
                    </form>}
                    {fetching === fetchingState.FETCHING &&
                        <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED &&
                        <Alert bsStyle='success'>УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED &&
                        <Alert bsStyle='danger'>
                        <p>ОШИБКА!</p>
                        {crudError && <p>{crudError}</p>}
                    </Alert>}
                </Modal.Body>
                {formVisible && <Modal.Footer>
                    <Button bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)} disabled={pristine}>Сохранить</Button>
                    <Button type="button" onClick={onClose}>Отмена</Button>
                </Modal.Footer>}
                {closeButtonVisible &&
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>}
            </Modal>
        );
    }
}

EditModal = reduxForm({
    form: 'documentEdit',
    validate, 
})(EditModal);

EditModal = connect(state => ({
    fetching: state.application.get('settings')[documents].updateFetching,
    crudError: state.application.get('settings')[documents].updateError
}))(EditModal);

export default EditModal;


// WEBPACK FOOTER //
// ./src/components/settings/documents/EditModal.jsx